export type ClubRole = 'developer' | 'owner' | 'admin' | 'player' | 'referee' | 'observer' | 'viewer';

export const CLUB_ROLE_LABELS: Record<ClubRole, string> = {
  developer: 'Разработчик',
  owner: 'Владелец',
  admin: 'Администратор',
  player: 'Игрок',
  referee: 'Судья',
  observer: 'Транслятор',
  viewer: 'Наблюдатель',
};
